import { useState } from "react";
import GroupDetails from "./GroupDetails";
import GroupBalanceDetails from "./GroupBalanceDetails";

const ExpensesDetails = () => {
  const [index, setIndex] = useState(0);

  return (
    <>
      {index === 0 ? (
        <GroupDetails setIndex={setIndex} />
      ) : (
        <GroupBalanceDetails />
      )}
    </>
  );
};

export default ExpensesDetails;
